import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropPrimaryData, setFootprintingCropPrimaryDataAdmin } from "services";

import { footprintingCropPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_AUTOFILL_APPLIED, FOOTPRINTING_CROP_PRIMARY_DATA } from "consts";

type CreateCropPrimaryDataPayload = {
  selectedCropIds: string[];
  autofillYear?: number;
};

export const useMutateFootprintingCropCreateManyBlankPrimaryData = (farmId: string, cropIds: string[], year: number) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_PRIMARY_DATA, farmId, ...cropIds],
      mutationFn: async ({ selectedCropIds, autofillYear }: CreateCropPrimaryDataPayload) => {
        await Promise.all(
          selectedCropIds.map((cropId) =>
            isAdmin
              ? setFootprintingCropPrimaryDataAdmin({ cropId, farmId, year }, undefined)
              : setFootprintingCropPrimaryData({ cropId, farmId, year }, undefined, { autofillYear })
          )
        );
      },
      onSuccess: async (_data, variables) => {
        if (variables?.autofillYear) {
          variables.selectedCropIds.forEach((cropId) => {
            queryClient.setQueryData([FOOTPRINTING_AUTOFILL_APPLIED, "crop", farmId, cropId, year], true);
          });
        }
        cropIds.forEach((cId) => {
          invalidateAndRefecthQueries(queryClient, [...footprintingCropPrimaryQueryKeys("", farmId, cId, year, isAdmin)]);
        });
      },
    },
    queryClient
  );
};
